import React, { useCallback, useEffect, useState } from 'react';
interface Buyer {
  initial: string;
  name: string;
  time: string;
}
const buyers: Buyer[] = [{
  initial: 'C',
  name: 'Carmen de Ciudad de México',
  time: 'hace 2 minutos'
}, {
  initial: 'M',
  name: 'María de Bogotá',
  time: 'hace 5 minutos'
}, {
  initial: 'P',
  name: 'Patricia de Miami',
  time: 'hace 8 minutos'
}, {
  initial: 'L',
  name: 'Laura de Buenos Aires',
  time: 'hace 11 minutos'
}, {
  initial: 'G',
  name: 'Gloria de Madrid',
  time: 'hace 15 minutos'
}, {
  initial: 'S',
  name: 'Sandra de Lima',
  time: 'hace 18 minutos'
}, {
  initial: 'A',
  name: 'Ana de Monterrey',
  time: 'hace 22 minutos'
}, {
  initial: 'R',
  name: 'Rosa de Santiago',
  time: 'hace 26 minutos'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const showPopup = useCallback(() => {
    setBuyerIndex(prev => (prev + 1) % buyers.length);
    setVisible(true);
    setTimeout(() => setVisible(false), 4000);
  }, []);
  useEffect(() => {
    const firstTimeout = setTimeout(() => {
      showPopup();
      const interval = setInterval(showPopup, Math.floor(Math.random() * 15000) + 25000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(firstTimeout);
  }, [showPopup]);
  const buyer = buyers[buyerIndex];
  return <div className={`fixed bottom-6 left-6 z-[9997] bg-white rounded-card py-3.5 px-[18px] flex items-center gap-3 max-w-[300px] border-l-4 border-verde-bosque transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] md:bottom-6 md:left-6 ${visible ? 'translate-x-0' : '-translate-x-[400px]'}`} style={{
    boxShadow: '0 8px 30px rgba(0,0,0,0.15)'
  }} aria-live="polite" data-id="element-241">
      <div className="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold text-[0.85rem] flex-shrink-0" style={{
      background: 'linear-gradient(135deg, #2B4A42, #C9A84C)'
    }} data-id="element-242">
        {buyer.initial}
      </div>
      <div className="text-[0.8rem] text-negro-carbon leading-[1.4]" data-id="element-243">
        <strong className="text-verde-bosque" data-id="element-244">{buyer.name}</strong> acaba de
        descargar el protocolo
        <div className="text-[0.7rem] text-gris-suave mt-0.5" data-id="element-245">{buyer.time}</div>
      </div>
    </div>;
}